import React, { useState, createContext } from "react";
import moment from 'moment';

export const DateContext = createContext()

export const DateContextProvider = (props) => {

  //日付をJST基準に変換して返す
  const parseAsMoment = (dateTimeStr) => {
    return moment.utc(dateTimeStr, 'YYYY-MM-DDTHH:mm:00Z', 'ja').utcOffset(9)
  }

  //日付形式に変換して返す
  const toUtcIso8601str = (momentInstance) => {
    return momentInstance
      .clone()
      .utc()
      .format('YYYY-MM-DDTHH:mm:00Z')
  }

  //検索対象開始日
  //const startD = moment().subtract(7, 'days');//一週間前
  //const [startDate, setStartDate] = useState(moment(startD.toISOString()).format('YYYY-MM-DD'));//一週間前
  //const [startDate, setStartDate] = useState(toUtcIso8601str(moment().subtract(7, 'days')));//一週間前
  //console.log('コンテキストのstartDate\n' + startDate)
  const [startDate, setStartDate] = useState(moment().subtract(7, "days").format("YYYY-MM-DD"));//見てる当日まで


  //検索対象終了日
  //const endD = moment().subtract(1, 'day');//前日（見てる日の前日）
  const endD = moment().subtract(0, 'day');//見てる当日まで
  //const [endDate, setEndDate] = useState(moment().subtract(1, "day").format("YYYY-MM-DD"));//前日（見てる日の前日）
  const [endDate, setEndDate] = useState(moment().subtract(0, "day").format("YYYY-MM-DD"));//見てる当日まで
  //console.log('コンテキストのendDate\n' + endDate)

  //先月(日次締めの月次選択で使用)
  const [lastMonth, setLastMonth] = useState(moment().add(-1, 'months').startOf('month').format("YYYY-MM"));

  //日次締めの締め日（デフォルトを変更された場合その日付けを覚えるため用）
  const today = new Date();//今現在
  today.setDate(today.getDate() - 1);//前日をデフォルトにする場合使う
  //console.log('today:' + today);
  const [dailyClosingStartDate, setDailyClosingStartDate] = useState(today);//デフォルトは前日


  //カレンダーのフォーマット形式
  const [selectFormat, setSelectFormat] = useState("yyyy/MM/dd")
  const [showMonthYearPicker, setshowMonthYearPicker] = useState(false)
  const [showYearPicker, setshowYearPicker] = useState(false)


  //日月年のボタンアクティブ
  const [activeDay, setActiveDay] = useState('active');
  const [activeMonth, setActiveMonth] = useState('');
  const [activeYear, setActiveYear] = useState('');


  return (
    <DateContext.Provider
      value={{
        startDate, setStartDate,
        endDate, setEndDate,
        lastMonth, setLastMonth,
        dailyClosingStartDate, setDailyClosingStartDate,
        selectFormat, setSelectFormat,
        showMonthYearPicker, setshowMonthYearPicker,
        showYearPicker, setshowYearPicker,
        activeDay, setActiveDay,
        activeMonth, setActiveMonth,
        activeYear, setActiveYear
      }}
    >
      {props.children}
    </DateContext.Provider>
  )
}